/*
 * MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
 * Email: mythpe@gmail.com
 * Mobile: +966590470092
 * Website: https://www.4myth.com
 */

import names from './attributes'
const messages = require('vee-validate/dist/locale/en.json')

export default {
  code: 'en',
  messages: {
    ...messages,
    int: 'The {_field_} field must be a valid integer',
    mobile: 'The {_field_} must be a valid mobile number',
    array_size: '{_field_} Not valid'
  },
  names,
  fields: {}
}
